const toAbsoluteUrl = (value: string, baseUrl: string): string | null => {
  const trimmed = value.trim();

  if (!trimmed) {
    return null;
  }

  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:')) {
    return trimmed;
  }

  const origin = baseUrl.replace(/\/+$/, '');
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;

  return origin ? `${origin}${path}` : path;
};

/**
 * Normalize Products API logo payloads (plain string URL/path or object wrappers)
 * into an absolute URL the `<img>` tag can load.
 */
export const resolveBrandLogoUrl = (
  data: unknown,
  baseUrl: string
): string | null => {
  if (!data) {
    return null;
  }

  if (typeof data === 'string') {
    return toAbsoluteUrl(data, baseUrl);
  }

  if (typeof data === 'object') {
    const payload = data as Record<string, unknown>;
    const raw =
      payload.logoUrl ??
      payload.url ??
      payload.logo ??
      payload.path ??
      payload.logoPath;

    if (typeof raw === 'string') {
      return toAbsoluteUrl(raw, baseUrl);
    }
  }

  return null;
};
